import React, { FC } from 'react';
import { Col, Empty, Row, Skeleton } from 'antd';
import { DollarOutlined, TagOutlined } from '@ant-design/icons';
import useListActivitiesQuery from 'apollo/resolvers/activity/list';
import { Activity } from 'apollo/generated/types';
import ActivityNumberCard, {
  ActivityNumberCardProps,
} from 'components/views/CanopyConfiguration/ActivityNumberCard';
import AvailabilitySection from 'components/views/CanopyConfiguration/AvailabilitySection';
import { CANOPY_ACTIVITY_TYPE_ID } from 'components/views/CanopyConfiguration/types';
import * as texts from 'assets/texts/canopyConfiguration';
import styles from './CanopyConfiguration.module.scss';

type NumberCardConfig = Pick<
  ActivityNumberCardProps,
  'field' | 'min' | 'icon' | 'thousandsSeparator' | 'texts'
>;

const numberCards: NumberCardConfig[] = [
  {
    field: 'maxStock',
    min: 0,
    icon: <TagOutlined />,
    texts: {
      title: texts.dailyLimit,
      hint: texts.dailyLimitHint,
      button: texts.dailyLimitButton,
      success: texts.dailyLimitUpdated,
      error: texts.dailyLimitError,
    },
  },
  {
    field: 'value',
    min: 1,
    icon: <DollarOutlined />,
    thousandsSeparator: true,
    texts: {
      title: texts.price,
      hint: texts.priceHint,
      button: texts.priceButton,
      success: texts.priceUpdated,
      error: texts.priceError,
    },
  },
];

const CanopyConfiguration: FC = () => {
  const { data, loading, refetch } = useListActivitiesQuery(CANOPY_ACTIVITY_TYPE_ID);
  const canopy: Activity | undefined = data?.listActivitiesBackOffice[0];

  return (
    <>
      <Row>
        <Col>
          <h2 className={styles.Title}>{texts.title}</h2>
        </Col>
      </Row>
      <Skeleton loading={loading} active>
        {canopy ? (
          <>
            <Row className={styles.Row} gutter={[16, 16]}>
              {numberCards.map((card) => (
                <Col key={card.field} xs={24} sm={12}>
                  <ActivityNumberCard
                    {...card}
                    activityId={canopy.id}
                    initialValue={canopy[card.field]}
                    refetch={refetch}
                  />
                </Col>
              ))}
            </Row>
            <AvailabilitySection activityId={canopy.id} />
          </>
        ) : (
          <Empty description={texts.notFound} />
        )}
      </Skeleton>
    </>
  );
};

export default CanopyConfiguration;
